import React, {useContext, useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { useNavigate } from 'react-router-dom';
import { Home_context } from '../../context/home_context';
import { searchClient } from '@algolia/client-search';
import SearchBar from '../../component/home_componets/search_bar';
import { Text } from '@chakra-ui/react';
import Raw_materials_listing_component from '../../component/home_componets/product_listing_component';
import Raw_product_listing from '../../component/home_componets/product_listing';
export default function Home() {
  const { value,setValue,HendleSelect, items, HendleChange } = useContext(Home_context);

const client = searchClient('ALGOLIA_APPLICATION_ID', 'ALGOLIA_API_KEY');
    const itemTemplate = (item) => {
        return (
          <div className="flex align-items-center flex-col">
            <p className='text-[black] text-[17px]'>{item.rm_name}</p>
            <p className='text-[#c4c4c4] text-[14px]' >{item.rm_name_en}</p>
          </div>
        )
    }

  return (
    <div
      className="w-[100%] translate-y-1"
      style={{ minHeight: 'calc(100vh - 100px)' }}
    >
    
      {/* <div className="  Home_search card flex justify-content-center">
        <AutoComplete
          placeholder="Search"
          value={value}
          suggestions={items}
          completeMethod={HendleChange}
          onChange={(e) => setValue(e.value)}
          onSelect={(e) => HendleSelect(e)}
          itemTemplate={itemTemplate}
        />
      </div> */}
      <SearchBar />
      <br />
      <Raw_product_listing/>
    </div>
  );
}


